import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ScrollReveal } from '../components/ScrollReveal';
import { MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
export function ContactPage() {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    businessName: '',
    service: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
      setFormState({
        name: '',
        email: '',
        businessName: '',
        service: '',
        message: ''
      });
      setTimeout(() => setIsSuccess(false), 5000);
    }, 1500);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value
    });
  };
  return <div className="w-full pt-32 pb-24 px-6 md:px-12" data-id="element-112">
      <div className="max-w-7xl mx-auto" data-id="element-113">
        <ScrollReveal className="mb-16" data-id="element-114">
          <h1 className="text-5xl md:text-7xl font-heading font-bold text-teal mb-6" data-id="element-115">
            Let's work together.
          </h1>
          <p className="text-xl text-teal/80 max-w-2xl" data-id="element-116">
            Whether you're ready to start or just exploring options, we'd love
            to hear from you.
          </p>
        </ScrollReveal>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16" data-id="element-117">
          {/* Form */}
          <div className="lg:col-span-7" data-id="element-118">
            <ScrollReveal delay={0.2} data-id="element-119">
              <form onSubmit={handleSubmit} className="bg-white/50 rounded-3xl p-8 md:p-10 border border-white/60 shadow-sm" data-id="element-120">
                {isSuccess ? <div className="text-center py-16" data-id="element-121">
                    <div className="w-20 h-20 bg-sage rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-122">
                      <svg className="w-10 h-10 text-teal" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-123">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-124" />
                      </svg>
                    </div>
                    <h3 className="text-3xl font-heading font-bold text-teal mb-4" data-id="element-125">
                      Inquiry Sent!
                    </h3>
                    <p className="text-teal/80 text-lg" data-id="element-126">
                      Thank you for reaching out. We'll get back to you shortly.
                    </p>
                  </div> : <div className="space-y-6" data-id="element-127">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-128">
                      <div className="space-y-2" data-id="element-129">
                        <label htmlFor="name" className="text-sm font-semibold text-teal" data-id="element-130">
                          Name
                        </label>
                        <input type="text" id="name" name="name" required value={formState.name} onChange={handleChange} className="w-full bg-white border border-teal/10 rounded-xl px-4 py-3 text-teal focus:outline-none focus:ring-2 focus:ring-coral/50 transition-all" placeholder="Jane Doe" data-id="element-131" />
                      </div>
                      <div className="space-y-2" data-id="element-132">
                        <label htmlFor="email" className="text-sm font-semibold text-teal" data-id="element-133">
                          Email
                        </label>
                        <input type="email" id="email" name="email" required value={formState.email} onChange={handleChange} className="w-full bg-white border border-teal/10 rounded-xl px-4 py-3 text-teal focus:outline-none focus:ring-2 focus:ring-coral/50 transition-all" placeholder="jane@example.com" data-id="element-134" />
                      </div>
                    </div>

                    <div className="space-y-2" data-id="element-135">
                      <label htmlFor="businessName" className="text-sm font-semibold text-teal" data-id="element-136">
                        Business Name
                      </label>
                      <input type="text" id="businessName" name="businessName" value={formState.businessName} onChange={handleChange} className="w-full bg-white border border-teal/10 rounded-xl px-4 py-3 text-teal focus:outline-none focus:ring-2 focus:ring-coral/50 transition-all" placeholder="Your Company LLC" data-id="element-137" />
                    </div>

                    <div className="space-y-2" data-id="element-138">
                      <label htmlFor="service" className="text-sm font-semibold text-teal" data-id="element-139">
                        Services Interested In
                      </label>
                      <select id="service" name="service" required value={formState.service} onChange={handleChange} className="w-full bg-white border border-teal/10 rounded-xl px-4 py-3 text-teal focus:outline-none focus:ring-2 focus:ring-coral/50 transition-all appearance-none" data-id="element-140">
                        <option value="" disabled data-id="element-141">
                          Select a service...
                        </option>
                        <option value="Marketing Strategy" data-id="element-142">
                          Marketing Strategy
                        </option>
                        <option value="Social Media Management" data-id="element-143">
                          Social Media Management
                        </option>
                        <option value="Content Creation" data-id="element-144">
                          Content Creation
                        </option>
                        <option value="Full Package" data-id="element-145">Full Package</option>
                      </select>
                    </div>

                    <div className="space-y-2" data-id="element-146">
                      <label htmlFor="message" className="text-sm font-semibold text-teal" data-id="element-147">
                        Message
                      </label>
                      <textarea id="message" name="message" required rows={5} value={formState.message} onChange={handleChange} className="w-full bg-white border border-teal/10 rounded-xl px-4 py-3 text-teal focus:outline-none focus:ring-2 focus:ring-coral/50 transition-all resize-none" placeholder="Tell us about your project..." data-id="element-148" />
                    </div>

                    <motion.button whileHover={{
                  scale: 1.02
                }} whileTap={{
                  scale: 0.98
                }} disabled={isSubmitting} type="submit" className="w-full bg-coral text-white py-4 rounded-xl font-bold text-lg hover:bg-coral-light transition-colors disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-149">
                      {isSubmitting ? 'Sending...' : 'Submit Inquiry'}
                    </motion.button>
                  </div>}
              </form>
            </ScrollReveal>
          </div>

          {/* Contact Info */}
          <div className="lg:col-span-5" data-id="element-150">
            <ScrollReveal delay={0.4} data-id="element-151">
              <div className="bg-teal text-cream rounded-3xl p-8 md:p-10 h-full" data-id="element-152">
                <h3 className="text-3xl font-heading font-bold mb-8" data-id="element-153">
                  Contact Information
                </h3>

                <div className="space-y-8" data-id="element-154">
                  <a href="mailto:Lauren@Forerivercreativeco.com" className="flex items-start gap-4 group" data-id="element-155">
                    <div className="w-12 h-12 rounded-full bg-cream/10 flex items-center justify-center shrink-0 group-hover:bg-coral transition-colors" data-id="element-156">
                      <MailIcon size={20} data-id="element-157" />
                    </div>
                    <div data-id="element-158">
                      <p className="text-sm text-cream/60 mb-1" data-id="element-159">Email</p>
                      <p className="font-medium group-hover:text-coral transition-colors break-all" data-id="element-160">
                        Lauren@Forerivercreativeco.com
                      </p>
                    </div>
                  </a>

                  <a href="tel:7819857277" className="flex items-start gap-4 group" data-id="element-161">
                    <div className="w-12 h-12 rounded-full bg-cream/10 flex items-center justify-center shrink-0 group-hover:bg-coral transition-colors" data-id="element-162">
                      <PhoneIcon size={20} data-id="element-163" />
                    </div>
                    <div data-id="element-164">
                      <p className="text-sm text-cream/60 mb-1" data-id="element-165">Phone</p>
                      <p className="font-medium group-hover:text-coral transition-colors" data-id="element-166">
                        781-985-7277
                      </p>
                    </div>
                  </a>

                  <div className="flex items-start gap-4" data-id="element-167">
                    <div className="w-12 h-12 rounded-full bg-cream/10 flex items-center justify-center shrink-0" data-id="element-168">
                      <MapPinIcon size={20} data-id="element-169" />
                    </div>
                    <div data-id="element-170">
                      <p className="text-sm text-cream/60 mb-1" data-id="element-171">Location</p>
                      <p className="font-medium" data-id="element-172">Weymouth, MA</p>
                    </div>
                  </div>
                </div>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </div>;
}